<template>
  <!--
    ValueProps — three-point "why Renants" strip.
    Placed between the main listings (GridView / Nearby Cities) and the footer
    so it becomes a subtle closing pitch for users who scrolled the whole page.
    Intentionally kept card-free and low-chrome so it doesn't compete with
    listing cards above it.
  -->
  <section class="value-props" aria-label="Why choose Renants">
    <div class="value-props-inner">
      <h2 class="value-props-title">Why Renants?</h2>
      <p class="value-props-sub">Built for local communities, not algorithms.</p>

      <div class="value-props-grid">
        <div class="value-prop">
          <div class="value-prop-icon value-prop-icon--blue">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 6v6l4 2"/>
            </svg>
          </div>
          <h3 class="value-prop-title">Post in 60 Seconds</h3>
          <p class="value-prop-desc">
            No signup wall, no credit card. Share your listing with the community in under a minute — completely free.
          </p>
        </div>

        <div class="value-prop">
          <div class="value-prop-icon value-prop-icon--green">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M20 6 9 17l-5-5"/>
            </svg>
          </div>
          <h3 class="value-prop-title">Hyper-Local Reach</h3>
          <p class="value-prop-desc">
            Filter by city and distance. Every listing is tied to a real place, so you only see what's actually nearby.
          </p>
        </div>

        <div class="value-prop">
          <div class="value-prop-icon value-prop-icon--purple">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
          </div>
          <h3 class="value-prop-title">Verified Community</h3>
          <p class="value-prop-desc">
            Email-verified accounts and a real contact flow — no scraped junk, no spam bots. Talk to real people.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ValueProps",
};
</script>

<style scoped>
.value-props {
  width: 100%;
  padding: 56px 20px 72px;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  border-top: 1px solid #eef0f3;
}

.value-props-inner {
  max-width: 1216px;
  margin: 0 auto;
  text-align: center;
}

.value-props-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 1.2;
  color: #181d27;
  margin: 0 0 8px;
}

.value-props-sub {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  color: #6b7280;
  margin: 0 0 40px;
}

.value-props-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  text-align: left;
}

.value-prop {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  background: #ffffff;
  border: 1px solid #eef0f3;
  border-radius: 14px;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.value-prop:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(10, 13, 18, 0.08);
  border-color: #e2e6eb;
}

.value-prop-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  margin-bottom: 16px;
}

.value-prop-icon--blue {
  background: linear-gradient(135deg, rgba(52, 103, 213, 0.12) 0%, rgba(52, 103, 213, 0.22) 100%);
  color: #3467d5;
}

.value-prop-icon--green {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.12) 0%, rgba(22, 163, 74, 0.22) 100%);
  color: #16a34a;
}

.value-prop-icon--purple {
  background: linear-gradient(135deg, rgba(147, 51, 234, 0.12) 0%, rgba(126, 34, 206, 0.22) 100%);
  color: #7e22ce;
}

.value-prop-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 17px;
  color: #181d27;
  margin: 0 0 6px;
}

.value-prop-desc {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 1.55;
  color: #6b7280;
  margin: 0;
}

/* Tablet */
@media (max-width: 900px) {
  .value-props-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    max-width: 520px;
    margin: 0 auto;
  }
}

/* Mobile */
@media (max-width: 600px) {
  .value-props {
    padding: 40px 16px 48px;
  }

  .value-props-title {
    font-size: 22px;
  }

  .value-props-sub {
    font-size: 14px;
    margin-bottom: 28px;
  }

  .value-prop {
    padding: 20px;
  }
}
</style>
